<template>
  <div id="main" style="opacity: 1;">
    <!-- header -->
    <app-header />
    <MobileFixedMenu />

    <!-- header end  -->
    <section class="breadscrumb-section pt-0">
      <div class="container-fluid-lg">
        <div class="row">
          <div class="col-12">
            <div class="breadscrumb-contain">
              <h2>Page Not Found</h2>
              <nav>
                <ol class="breadcrumb mb-0">
                  <li class="breadcrumb-item">
                    <a href="/">
                      <i class="fa-solid fa-house"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">404</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-404 section-lg-space">
      <div class="container-fluid-lg">
        <div class="row">
          <div class="col-12">
            <div class="image-404">
              <img src="/assets/images/inner-page/404.png" class="img-fluid blur-up lazyloaded" alt="">
            </div>
          </div>

          <div class="col-12">
            <div class="contain-404">
              <h3 class="text-content">The page you are looking for could not be found. The link to this
                address may be outdated or we may have been removed.</h3>
              <router-link to="/" class="btn btn-md text-white theme-bg-color mt-4 mx-auto">
                Back To Home Page
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FooterComponent />
  </div>
</template>

<script>
import FooterComponent from '@/components/Sections/Footer'
import AppHeader from '@/components/Sections/Header'
import MobileFixedMenu from '@/components/Shared/MobileFixedMenu.vue'

export default {
  name: 'NotFoundComponent',
  data() {
    return {
      form: {}
    }
  },
  components: {
    MobileFixedMenu,
    FooterComponent,
    AppHeader
  },
  mounted() {
    document.title = '404 Page not found.'
  }
}
</script>
